import {BASE_AD_TAG, sectionAd} from "@/components/adSections/index";

export function hideAdsWrappers() {
  const uniqueTags = new Set(Object.values(BASE_AD_TAG));
  uniqueTags.forEach((tag) => {
    const elements = document.querySelectorAll(`#${tag}`);
    elements.forEach((element) => {
      const adHidden = window.getComputedStyle(element).display;
      const childExist = element.childElementCount > 0;
      const adIframeExist = element.querySelector("iframe");
      if (adHidden === "none" || (!childExist && !adIframeExist)) {
        if (sectionAd.includes(tag)) {
          (element as HTMLElement).style.display = "none";
        }
        if (tag === BASE_AD_TAG.stickyMobile) {
          const parentElement = element.parentElement;
          if (!parentElement) {
            throw new Error("Expected stickyMobile ad element to have a parent");
          }
          const formParentElement = parentElement.parentElement;
          (formParentElement as HTMLElement).style.display = "none";
        }
      }
    });
  });
}

// "zoom" is a non-standard CSS property (Chromium/Safari browser zoom level), not in the DOM lib types
type StyleWithZoom = CSSStyleDeclaration & {zoom?: string};

export const resizeAdsZoom = () => {
  const zoom = (window.getComputedStyle(document.documentElement) as StyleWithZoom).zoom;
  const uniqueTags = new Set(Object.values(BASE_AD_TAG));

  uniqueTags.forEach((tag) => {
    const elements = document.querySelectorAll(`#${tag}`);
    elements.forEach((element) => {
      let zoomBlock = "1";
      let scale = 1;
      if (zoom === "0.75") {
        zoomBlock = "1.333";
      } else if (zoom === "0.5") {
        scale = 0.75;
        zoomBlock = "2";
      }

      const style = (element as HTMLElement).style;
      style.transform = `scale(${scale})`;
      style.transformOrigin = "0 0";
      (style as StyleWithZoom).zoom = zoomBlock;
    });
  });
};
